/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { analysisUnavailableOffblackStatic } from "../assets/analysis-unavailable-offblack-static";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconAnalysisUnavailableOffblackStatic = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={analysisUnavailableOffblackStatic.svg} />
);

IllustrativeIconAnalysisUnavailableOffblackStatic.displayName = "IllustrativeIconAnalysisUnavailableOffblackStatic";
